import { Model } from "@src/libs/model/model";

export class CustomerSingle extends Model {
  id: number = 0;
  code?: string = "";
  name: string = "";
  phone1?: string = "";
  email?: string = "";
}
